/* eslint-disable */
import type { AllocationDistribution } from "../../../AllocationDistribution.pb";
import type { AllocationDestination } from "../../../common.pb";

export interface SetPaycheckAllocationAmountInputs {
  submission_interaction?: SetPaycheckAllocationAmountInputsSubmissionInteraction;
  /**
   * An updated paycheck distribution after the customer has made any
   * changes.
   *
   * For the Paychecks MVP, the only difference from the distribution
   * provided to the client by the `SetPaycheckAllocationAmountBlocker`
   * should be to the destination specified by
   * `initially_selected_destination_index`. Submitting a
   * `BUTTON_TAP_CONFIRM` means that the user updated the share of
   * the allocation for `selected_destination`.
   *
   * Post Paychecks MVP, If a non-initially-selected destination with
   * `ALLOW_IMMEDIATE_SELECTION` was provided in the
   * `SetPaycheckAllocationAmountBlocker` instance the client is
   * is displaying, the other destinations in this field may need to be
   * updated as well.
   */
  updated_distribution?: AllocationDistribution;
  /**
   * The destination that was selected when the user made an interaction
   * that caused the blocker to be submitted.
   *
   * For the Paychecks MVP, you can expect this to always be the same
   * destination that was provided in the
   * `SetPaycheckAllocationAmountBlocker` that was sent to the client.
   *
   * If a non-initially-selected destination with
   * `ALLOW_IMMEDIATE_SELECTION` was provided in the
   * `SetPaycheckAllocationAmountBlocker` instance the client is
   * is displaying, this will be the destination they are currently
   * editing. This does not exclude the other destinations from having
   * changes that to be saved as well.
   */
  selected_destination?: AllocationDestination;
}

export enum SetPaycheckAllocationAmountInputsSubmissionInteraction {
  SUBMISSION_INTERACTION_UNSPECIFIED = "SUBMISSION_INTERACTION_UNSPECIFIED",
  /** SUBMISSION_INTERACTION_CANCEL - The customer cancelled the interaction with the blocker */
  SUBMISSION_INTERACTION_CANCEL = "SUBMISSION_INTERACTION_CANCEL",
  /** SUBMISSION_INTERACTION_BUTTON_TAP_CONFIRM - The customer tapped the "Confirm" button */
  SUBMISSION_INTERACTION_BUTTON_TAP_CONFIRM = "SUBMISSION_INTERACTION_BUTTON_TAP_CONFIRM",
  /** SUBMISSION_INTERACTION_BUTTON_TAP_DISABLE - The customer tapped the "Turn Off" button */
  SUBMISSION_INTERACTION_BUTTON_TAP_DISABLE = "SUBMISSION_INTERACTION_BUTTON_TAP_DISABLE",
  /**
   * SUBMISSION_INTERACTION_CONFIGURATION_ROW_TAP - The customer tapped the configuration row. In the Paychecks MVP,
   * that means they are selecting a stock
   */
  SUBMISSION_INTERACTION_CONFIGURATION_ROW_TAP = "SUBMISSION_INTERACTION_CONFIGURATION_ROW_TAP",
  /**
   * SUBMISSION_INTERACTION_DESTINATION_SELECTION_CHANGE - The customer tapped a chart segment for a different destination
   * that specified `SUBMIT_ON_SELECTION` as its `selection_behavior`.
   */
  SUBMISSION_INTERACTION_DESTINATION_SELECTION_CHANGE = "SUBMISSION_INTERACTION_DESTINATION_SELECTION_CHANGE",
}
